export const iconFontAwesomeAnimalsPaw = (
	<i className="fa-solid fa-paw"></i>
);
